import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import searchIcon from '../../../assets/img/search-icon.svg';
import { selectStudents, selectTeachers } from '../../../redux/slices/statistics/additionalStatisticsSlice';
import {
  resetAutocompleteFocus,
  selectIsAutocompleteFocused,
  selectSearchQuery,
  selectSelectedRole,
  setAutocompleteFocus,
  setCurrentUser,
  setSearchQuery,
} from '../../../redux/slices/statistics/statisticsSlice';
import { findObjectByFIO } from '../statisticsParentUtils';
import './style.scss';

const SearchAutocomplete = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentSearchQuery = useSelector(selectSearchQuery);
  const currentRole = useSelector(selectSelectedRole);
  const students = useSelector(selectStudents);
  const teachers = useSelector(selectTeachers);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (options.length > 0) {
      dispatch(setSearchQuery(options[0]));
    }
  }, [options, currentRole]);

  useEffect(() => {
    if (currentRole === 'Teacher') {
      const newArr1 = teachers.map(item => item.FIO);
      setOptions(newArr1);
    }
    if (currentRole === 'Student') {
      const newArr2 = students.map(item => item.FIO);
      setOptions(newArr2);
    }
  }, [students, teachers, currentRole]);

  useEffect(() => {
    if (currentRole === 'Teacher') {
      dispatch(setCurrentUser(findObjectByFIO(teachers, currentSearchQuery)));
    }
    if (currentRole === 'Student') {
      dispatch(setCurrentUser(findObjectByFIO(students, currentSearchQuery)));
    }
  }, [students, teachers, currentRole, currentSearchQuery]);

  const handleChange = (event, newValue) => {
    dispatch(setSearchQuery(newValue));
  };

  return (
    <div className="container-search">
      <Autocomplete
        className={currentSearchQuery ? 'search-autocomplete' : 'search-autocomplete input-cleared'}
        value={currentSearchQuery}
        options={options.sort()}
        getOptionLabel={option => option}
        onOpen={() => dispatch(setAutocompleteFocus())}
        onClose={() => dispatch(resetAutocompleteFocus())}
        onChange={handleChange}
        renderInput={params => (
          <>
            <TextField {...params} label={t('search')} variant="outlined" />
            <div className="search-icon">
              <img src={searchIcon} alt="search-icon" />
            </div>
          </>
        )}
      />
    </div>
  );
};

export default SearchAutocomplete;
